import { useEffect, useContext, useState, useRef } from "react";

import Map from "ol/Map";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import View from "ol/View";
import { transformExtent } from "ol/proj";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { fromExtent } from "ol/geom/Polygon";
import Feature from "ol/Feature";
import { defaults as defaultControls } from "ol/control.js";
import { useSelector } from "react-redux";
import { getLayerById } from "../map/mapUtils";
import store from "../../stores/store";
import { addLayer, key, trans } from "../../lib/utils";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

function LayerPreviewComponent(props) {
  const sources = useSelector((state) => store.getState().sources);
  const layers = useSelector((state) => store.getState().layers);

  const [layer, setLayer] = useState(null);
  const [source, setSource] = useState(null);
  const [layerMap, setLayerMap] = useState(null);

  const layerMapRef = useRef();

  useEffect(() => {
    if (!layer) {
      setLayer(props.layer);
    }
    if (!source) {
      setSource(sources[props.layer.source.id]);
    }
    if (layer && source && !layerMap) {
      const _layerMap = new Map({
        target: layerMapRef.current,
        layers: [
          new TileLayer({
            source: new OSM({ singleTile: true, ratio: 1 }),
          }),
        ],
        view: new View({
          projection: "EPSG:4326",
          center: [23.704764001367, 38.002281696053],
          zoom: 6,
        }),
        controls: defaultControls(),
      });

      const sourceDraw = new VectorSource({ wrapX: false });

      const vectorDrawLayer = new VectorLayer({
        source: sourceDraw,
      });

      const boxFeature = new Feature({
        geometry: fromExtent(layer.bbox),
      });

      vectorDrawLayer.getSource().addFeature(boxFeature);

      _layerMap.addLayer(vectorDrawLayer);

      _layerMap
        .getView()
        .fit(
          transformExtent(
            layer.bbox,
            "EPSG:4326",
            _layerMap.getView().getProjection().getCode()
          )
        );
      setLayerMap(_layerMap);
    }
  }, [layer, source, layers]);

  return layer ? (
    <PerfectScrollbar style={{ height: "calc(100vh - 25rem)" }}>
      <div className="me-3 mt-3">
        <div className="text-end mb-2" key={key()}>
          {!getLayerById(layer.id) ? (
            <button
              className=" btn btn-sm btn-success small"
              onClick={() => {
                addLayer(layer);
              }}
            >
              <span className="text-white">
                <i className="fas fa-plus  me-2"></i>
                {trans("Add to map")}
              </span>
            </button>
          ) : (
            <button
              className="btn btn-sm  btn-danger small"
              onClick={() => {
                store.dispatch({
                  type: "layer/deleteById",
                  payload: layer.id,
                });
              }}
            >
              <span className="text-white">
                <i className="fas fa-trash-alt  me-2"></i>
                {trans("Remove from map")}
              </span>
            </button>
          )}
        </div>
        <h3>{layer.title}</h3>
        <div className="mb-3">
          <label className="color-get-blue strong ">
            {trans("Layer Name")}
          </label>

          <div className="mt-1">
            <span className="text-secondary">{layer.name}</span>
          </div>
        </div>
        <div className="mb-3">
          <label className="color-get-blue strong ">
            {source.type === "GEOJSON"
              ? trans("Source type")
              : trans("Service type")}
          </label>
          <div className="mt-2">
            {source.type === "GEOJSON" ? source.name : source.type}
          </div>
        </div>
        {/* {layer.source.type === "GEOJSON" ? (
        <div className="mb-3">
          <label className="color-get-blue strong ">Number of features</label>
          <div className="mt-2">{node.layer.data.length}</div>
        </div>
      ) : (
        ""
      )} */}
        {layer.metadata.url ? (
          <div className="mb-3">
            <label className="color-get-blue strong ">
              {trans("Metadata source")}
            </label>
            <div className="mt-2">
              <a
                href={layer.metadata.url}
                target="_blank"
                className=" text-break"
              >
                {layer.metadata.url}
              </a>
            </div>
          </div>
        ) : null}
        {layer.source.type !== "GEOJSON" ? (
          <div className="mb-3">
            <label className="color-get-blue strong ">
              {trans("Layer Abastract")}
            </label>
            <div className="mt-2">{layer.abstract}</div>
          </div>
        ) : (
          ""
        )}
        <div className="mb-3">
          <label className="color-get-blue strong ">
            {trans("Layer Bounding Box")}
          </label>
          <div className="mt-2">
            <table className="table">
              <thead>
                <tr>
                  <th>{trans("Min X")}</th>
                  <th>{trans("Min Y")}</th>
                  <th>{trans("Max X")}</th>
                  <th>{trans("Max Y")}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{layer.bbox[0]}</td>
                  <td>{layer.bbox[1]}</td>
                  <td>{layer.bbox[2]}</td>
                  <td>{layer.bbox[3]}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="mt-2">
            <div
              ref={layerMapRef}
              style={{ position: "relative", width: "100%", height: "20rem" }}
            ></div>
          </div>
        </div>
        <div className="mb-3">
          <label className="color-get-blue strong ">
            {trans("Layer Legend")}
          </label>
          <div className="mt-2">
            <img src={layer.legend} />
          </div>
        </div>
        {layer.source.type !== "GEOJSON" ? (
          <>
            <h4 className="mt-2">{trans("Service information")}</h4>
            <div className="mb-3">
              <label className="color-get-blue strong ">
                {trans("Service Name")}
              </label>
              <div className="mt-2">{source.title}</div>
              <div className="mt-1">
                <span className="text-secondary">{source.url}</span>
              </div>
            </div>
            <div className="mb-3">
              <label className="color-get-blue strong ">
                {trans("Service Abstract")}
              </label>
              <div className="mt-2">{source.abstract}</div>
            </div>
            <div className="mb-3">
              <label className="color-get-blue strong ">
                {trans("Service contact information")}
              </label>
              <div className="mt-2">
                <table className="table">
                  <thead>
                    <tr>
                      <th>{trans("Access constrains")}</th>
                      <th>{trans("Fees")}</th>
                      <th>{trans("Responsible Party")}</th>
                      <th>{trans("Email")}</th>
                      <th>{trans("Person")}</th>
                      <th>{trans("Position")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{source.metadata.access_constrains}</td>
                      <td>{source.metadata.fees}</td>
                      <td>{source.metadata.responsible.party}</td>
                      <td>{source.metadata.responsible.email}</td>
                      <td>{source.metadata.responsible.person}</td>
                      <td>{source.metadata.responsible.position}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
    </PerfectScrollbar>
  ) : null;
}
export default LayerPreviewComponent;
